const demo_app = {
    notification: 'Совет: Создайте аккаунт сначала, чтобы протестировать процесс входа.',
};
export default demo_app;
